"use client";

import { c as _c } from "react/compiler-runtime";
import type { Filter } from "../types/filter";
import { useFilterActions } from "./use-filter-actions";
import { useOptions } from "./use-options";
interface FilterProps {
  filterTypes: Filter[];
  searchQuery?: string;
}

/**
 * Handles location filter actions and options
 *
 * @param {FilterProps} props - The filter properties including filter types and optional search query
 * @throws {Error} Throws an error if used with non-location filter types
 * @returns {Object} Combined object containing filter actions and options for location filtering
 */
export const useLocationFilter = props => {
  const $ = _c(3);
  const {
    filterTypes
  } = props;
  const actions = useFilterActions(filterTypes);
  const filterOptions = useOptions(props);
  if (!filterOptions.isLocation) {
    throw new Error("useLocationFilter must be used with location filter types only.");
  }
  let t0;
  if ($[0] !== actions || $[1] !== filterOptions) {
    t0 = {
      ...actions,
      ...filterOptions
    };
    $[0] = actions;
    $[1] = filterOptions;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};